(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/tipsen/match.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/tipsen/match.js');
"use strict";


svs.game_results.views.Match = Marionette.View.extend({
  template(data) {
    return svs.game_results.templates.match(data);
  },
  templateContext() {
    if (this.model.get('forecastResult')) {
      return {
        cancelledNoResult: this.model.get('drawCancelled') && this.model.get('forecastResult').outcome === 'n/a'
      };
    }
    return {
      cancelledNoResult: this.model.get('drawCancelled')
    };
  },
  className() {
    const className = 'js-expandable-box';
    return className;
  },
  modelEvents: {
    matchUpdated: 'render',
    'change:isLive': 'render',
    timeChanged: 'timeChanged'
  },
  ui: {
    matchTime: '.match-time'
  },
  timeChanged() {
    this.ui.matchTime.html(this.model.get('match').matchListText);
  }
});

 })(window);